module.exports = __webpack_public_path__ + "img/register.3dc289d9.jpg";